import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
  FunctionOnglet,
} from '../../../../../../manager/edro-network-manager';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ModalController } from '@ionic/angular/standalone';
import { IProduct, IProductFunctionnality } from '../../../../../IProduct';
import {
  LargedTuileComponent,
  TuileButtonProps,
} from '../../../../../../../../components/ecosystems/larged-tuile/larged-tuile.component';
import { P0003601SpeedChoiceComponent } from '../../../../P0003601/Component/p0003601-speed-choice/p0003601-speed-choice.component';
import { P00058SpeedChoiceComponent } from '../../../Component/p00058-speed-choice/p00058-speed-choice.component';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import {
  P00058ProgrammeFiltrationAuto,
  P00058ProgrammeFiltrationManuel,
} from '../../../Enum/P00058ProgrammeFiltrationAuto';
import { P00058AutoChoiceComponent } from '../../../Component/p00058-auto-choice/p00058-auto-choice.component';

@Component({
  selector: 'app-p00058-card-filtration-controle',
  templateUrl: './p00058-card-filtration-controle.component.html',
  styleUrls: ['./p00058-card-filtration-controle.component.scss'],
  imports: [LargedTuileComponent, TranslatePipe],
})
export class P00058CardFiltrationControleComponent implements OnInit {
  private edroNetworkManager = inject(EdroNetworkManager);
  private translateService = inject(TranslateService);
  private modalController = inject(ModalController);
  @Input() productClass: IProduct | null = null;
  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  getStatus() {
    const pvSVitesseCouranteRPM = this.actionStack!.getValue(
      'pvSVitesseCouranteRPM',
    );
    const pvPUniteConsignePompe = this.actionStack!.getValue(
      'pvPUniteConsignePompe',
    );
    const pvSVitesseMaxRpm = this.actionStack!.getValue('pvSVitesseMaxRpm');

    if (pvSVitesseCouranteRPM === 0) {
      return 'P0003601.card.status.stop';
    } else {
      if (pvPUniteConsignePompe === 0) {
        const pourcentage = Math.round(
          (pvSVitesseCouranteRPM * 100) / pvSVitesseMaxRpm,
        );
        return pourcentage + ' %';
      } else {
        return (
          pvSVitesseCouranteRPM +
          ' ' +
          this.translateService.instant('P00058.installation.rpm')
        );
      }
    }
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  buttons: TuileButtonProps[] = [
    {
      title: 'P00058.card.state.filtration.status.off',
      icon: 'fa-kit fa-picto-off',
      color: 'color-red',
      status: 'inactive',
    },
    {
      title: 'P00058.card.state.filtration.status.manuel',
      icon: '',
      color: 'color-green',
      status: 'active',
      onPress: () => {
        this.openManual().finally(() => {});
      },
    },
    {
      title: 'P00058.card.state.filtration.status.auto',
      icon: 'fa-kit fa-picto-programme',
      color: 'color-orange',
      status: 'active',
      onPress: () => {
        this.openAuto().finally(() => {});
      },
    },
    {
      title: 'P00058.card.state.filtration.status.ecremage',
      icon: 'fa-kit fa-picto-ecremage',
      color: 'color-orange',
      status: 'active',
    },
  ];

  getButtons(): TuileButtonProps[] {
    const vitesseManuelle =
      this.actionStack!.getValue('pvCProgrammeManuel') ?? 0;
    const programmeFiltrationAuto =
      this.actionStack!.getValue('pvCProgrammeAuto') ?? 0;

    let res = 'fa-kit fa-vs-v1';

    if (vitesseManuelle === 0) {
      res = 'fa-kit fa-vs-v1';
    } else if (vitesseManuelle === 1) {
      res = 'fa-kit fa-vs-v2';
    } else if (vitesseManuelle === 2) {
      res = 'fa-kit fa-vs-max';
    }

    this.buttons[1].icon = res;

    let res2 = 'fa-kit fa-vs-v1';

    if (programmeFiltrationAuto === 0) {
      res2 = 'fa-kit fa-picto-horlogeete';
    } else if (programmeFiltrationAuto === 1) {
      res2 = 'fa-kit fa-picto-horlogehiver';
    } else if (programmeFiltrationAuto === 2) {
      res2 = 'fa-kit fa-picto-horloge72h';
    } else if (programmeFiltrationAuto === 3) {
      res2 = 'fa-kit fa-vs-v2';
    }

    this.buttons[2].icon = res2;

    return this.buttons;
  }

  async openProductModal() {
    await this.edroNetworkManager.openProductModal(
      this.productClass!,
      IProductFunctionnality.FILTRATION_VS,
      FunctionOnglet.CONTROL,
      this.translateService.instant('dashboard.filtration'),
    );
  }

  async openManual() {
    const modal = await this.modalController.create({
      component: P00058SpeedChoiceComponent,
      componentProps: {
        value: this.actionStack!.getValue('pvCProgrammeManuel') ?? 0,
      },
      cssClass: 'dynamic-height',
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Controle,
        'pvCProgrammeManuel',
        data.value,
      );
      this.actionStack!.commit();
    }
  }

  async openAuto() {
    const modal = await this.modalController.create({
      component: P00058AutoChoiceComponent,
      componentProps: {
        value: this.actionStack!.getValue('pvCProgrammeAuto') ?? 0,
      },
      cssClass: 'dynamic-height',
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Controle,
        'pvCProgrammeAuto',
        data.value,
      );
      this.actionStack!.commit();
    }
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P00058ProgrammeFiltrationManuel =
    P00058ProgrammeFiltrationManuel;
  protected readonly P00058ProgrammeFiltrationAuto =
    P00058ProgrammeFiltrationAuto;
}
